// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "simsandbox/v1/simsandbox.proto" (package "simsandbox.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal RPCs for running a simulation sandbox against a machine part.
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message simsandbox.v1.CreateSimSandboxRequest
 */
export interface CreateSimSandboxRequest {
    /**
     * The part the sandbox runs against; the caller must have control access.
     *
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.CreateSimSandboxResponse
 */
export interface CreateSimSandboxResponse {
    /**
     * The sandbox's opaque identifier, for DestroySimSandbox and GetSimSandboxStatus.
     *
     * @generated from protobuf field: string sandbox_id = 1;
     */
    sandboxId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.DestroySimSandboxRequest
 */
export interface DestroySimSandboxRequest {
    /**
     * @generated from protobuf field: string sandbox_id = 1;
     */
    sandboxId: string;
    /**
     * @generated from protobuf field: simsandbox.v1.DestroyReason reason = 2;
     */
    reason: DestroyReason;
}
/**
 * @generated from protobuf message simsandbox.v1.DestroySimSandboxResponse
 */
export interface DestroySimSandboxResponse {
    /**
     * @generated from protobuf field: bool success = 1;
     */
    success: boolean;
}
/**
 * @generated from protobuf message simsandbox.v1.GetSimSandboxStatusRequest
 */
export interface GetSimSandboxStatusRequest {
    /**
     * @generated from protobuf field: string sandbox_id = 1;
     */
    sandboxId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.GetSimSandboxStatusResponse
 */
export interface GetSimSandboxStatusResponse {
    /**
     * @generated from protobuf field: simsandbox.v1.SandboxState state = 1;
     */
    state: SandboxState;
    /**
     * Set once the sandbox has failed or terminated.
     *
     * @generated from protobuf field: simsandbox.v1.TerminationCause termination_cause = 2;
     */
    terminationCause: TerminationCause;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 3;
     */
    startedAt?: Timestamp;
}
/**
 * @generated from protobuf message simsandbox.v1.GetSimSandboxPriceRequest
 */
export interface GetSimSandboxPriceRequest {
    /**
     * The part a sandbox would run against; the caller must have control access.
     *
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.GetSimSandboxPriceResponse
 */
export interface GetSimSandboxPriceResponse {
    /**
     * In USD. Unset when the org's billing tier sets no price for simulation.
     *
     * @generated from protobuf field: optional double usd_per_minute = 1;
     */
    usdPerMinute?: number;
    /**
     * Monthly credit in USD applied across all cloud services in the org's billing tier.
     *
     * @generated from protobuf field: double monthly_credit_usd = 2;
     */
    monthlyCreditUsd: number;
}
/**
 * @generated from protobuf message simsandbox.v1.GetMachineSimSandboxesRequest
 */
export interface GetMachineSimSandboxesRequest {
    /**
     * @generated from protobuf field: string machine_id = 1;
     */
    machineId: string;
}
/**
 * @generated from protobuf message simsandbox.v1.GetMachineSimSandboxesResponse
 */
export interface GetMachineSimSandboxesResponse {
    /**
     * At most one per part; parts that have never had a sandbox are omitted.
     *
     * @generated from protobuf field: repeated simsandbox.v1.SimSandbox sandboxes = 1;
     */
    sandboxes: SimSandbox[];
}
/**
 * SimSandbox is a part's most recently started sandbox.
 *
 * @generated from protobuf message simsandbox.v1.SimSandbox
 */
export interface SimSandbox {
    /**
     * @generated from protobuf field: string sandbox_id = 1;
     */
    sandboxId: string;
    /**
     * @generated from protobuf field: string part_id = 2;
     */
    partId: string;
    /**
     * As recorded rather than asked of the provider, so it lags the provider by
     * up to the container monitor's interval: a sandbox reads PROVISIONING until
     * it is confirmed running, and STARTED until an exit on its own is detected.
     *
     * @generated from protobuf field: simsandbox.v1.SandboxState state = 3;
     */
    state: SandboxState;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp started_at = 4;
     */
    startedAt?: Timestamp;
    /**
     * Set once the sandbox has failed or terminated.
     *
     * @generated from protobuf field: simsandbox.v1.TerminationCause termination_cause = 5;
     */
    terminationCause: TerminationCause;
}
/**
 * @generated from protobuf message simsandbox.v1.GetSimSandboxStatsRequest
 */
export interface GetSimSandboxStatsRequest {
    /**
     * Start of the window, inclusive. Sandboxes are filtered and bucketed by when they were
     * launched (started_at). Unset defaults to 7 days before end.
     *
     * @generated from protobuf field: google.protobuf.Timestamp start = 1;
     */
    start?: Timestamp;
    /**
     * End of the window, exclusive. Unset defaults to now.
     *
     * @generated from protobuf field: google.protobuf.Timestamp end = 2;
     */
    end?: Timestamp;
}
/**
 * SimSandboxCountStat is how many sandboxes share one value of some field.
 *
 * @generated from protobuf message simsandbox.v1.SimSandboxCountStat
 */
export interface SimSandboxCountStat {
    /**
     * @generated from protobuf field: string key = 1;
     */
    key: string;
    /**
     * @generated from protobuf field: int64 count = 2;
     */
    count: string;
}
/**
 * SimSandboxLocationStat is one provider location, e.g. a GKE node pool, over the window: the
 * sandboxes that ended up there, and how placement treated it.
 *
 * @generated from protobuf message simsandbox.v1.SimSandboxLocationStat
 */
export interface SimSandboxLocationStat {
    /**
     * The location as recorded on the sandbox; empty for a provider with only one.
     *
     * @generated from protobuf field: string location = 1;
     */
    location: string;
    /**
     * @generated from protobuf field: string provider = 2;
     */
    provider: string;
    /**
     * Sandboxes launched in the window that ran, or last waited, here.
     *
     * @generated from protobuf field: int64 launches = 3;
     */
    launches: string;
    /**
     * Of those, how many were confirmed running.
     *
     * @generated from protobuf field: int64 started = 4;
     */
    started: string;
    /**
     * Of those, how many were first placed somewhere other than their preferred location.
     *
     * @generated from protobuf field: int64 spilled = 5;
     */
    spilled: string;
    /**
     * Sandboxes moved here from another location while waiting for a machine, and moved away from here.
     *
     * @generated from protobuf field: int64 relocated_in = 6;
     */
    relocatedIn: string;
    /**
     * @generated from protobuf field: int64 relocated_out = 7;
     */
    relocatedOut: string;
    /**
     * Sandboxes destroyed here for want of a machine by the provisioning deadline.
     *
     * @generated from protobuf field: int64 abandoned = 8;
     */
    abandoned: string;
    /**
     * Of the started, how many were running within the warm-start threshold of their launch: a time only a
     * machine that was already up can meet.
     *
     * @generated from protobuf field: int64 warm_starts = 9;
     */
    warmStarts: string;
    /**
     * Sandboxes provisioning or started here right now, launched in the window or not.
     *
     * @generated from protobuf field: int64 active_now = 10;
     */
    activeNow: string;
    /**
     * Time from launch to confirmed running, over the started sandboxes. Unset when none started.
     *
     * @generated from protobuf field: optional int64 time_to_running_p50_ms = 11;
     */
    timeToRunningP50Ms?: string;
    /**
     * @generated from protobuf field: optional int64 time_to_running_p95_ms = 12;
     */
    timeToRunningP95Ms?: string;
    /**
     * Hours run here during the window, by any sandbox whose run overlaps it, each counted from confirmed running
     * until it ended or, if still running, now, and clipped to the window.
     *
     * @generated from protobuf field: double running_hours = 13;
     */
    runningHours: number;
    /**
     * running_hours priced at the location's node rate. Zero when the location has no node rate.
     *
     * @generated from protobuf field: double estimated_runtime_cost_usd = 14;
     */
    estimatedRuntimeCostUsd: number;
}
/**
 * SimSandboxDailyStat is one calendar day in the America/New_York time zone. Days with no launches and no running
 * time are omitted.
 *
 * @generated from protobuf message simsandbox.v1.SimSandboxDailyStat
 */
export interface SimSandboxDailyStat {
    /**
     * The day, as YYYY-MM-DD.
     *
     * @generated from protobuf field: string date = 1;
     */
    date: string;
    /**
     * Sandboxes launched that day.
     *
     * @generated from protobuf field: int64 launches = 2;
     */
    launches: string;
    /**
     * @generated from protobuf field: int64 started = 3;
     */
    started: string;
    /**
     * @generated from protobuf field: int64 failed = 4;
     */
    failed: string;
    /**
     * Hours run during that day, within the window, so a long run spreads over the days it spanned. A sandbox still
     * running counts up to now.
     *
     * @generated from protobuf field: double running_hours = 5;
     */
    runningHours: number;
}
/**
 * SimSandboxOrgStat is one row of the organization leaderboard, ranked by running_hours: launches are those the
 * org started in the window, running_hours what its sandboxes ran during it, so a row can have one without the other.
 *
 * @generated from protobuf message simsandbox.v1.SimSandboxOrgStat
 */
export interface SimSandboxOrgStat {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
    /**
     * Empty if the org could not be resolved.
     *
     * @generated from protobuf field: string org_name = 2;
     */
    orgName: string;
    /**
     * @generated from protobuf field: int64 launches = 3;
     */
    launches: string;
    /**
     * @generated from protobuf field: double running_hours = 4;
     */
    runningHours: number;
}
/**
 * SimSandboxPartStat is one row of the part leaderboard, ranked and counted as SimSandboxOrgStat is.
 *
 * @generated from protobuf message simsandbox.v1.SimSandboxPartStat
 */
export interface SimSandboxPartStat {
    /**
     * @generated from protobuf field: string part_id = 1;
     */
    partId: string;
    /**
     * Empty if the part could not be resolved.
     *
     * @generated from protobuf field: string part_name = 2;
     */
    partName: string;
    /**
     * @generated from protobuf field: string machine_id = 3;
     */
    machineId: string;
    /**
     * @generated from protobuf field: string org_id = 4;
     */
    orgId: string;
    /**
     * @generated from protobuf field: int64 launches = 5;
     */
    launches: string;
    /**
     * @generated from protobuf field: double running_hours = 6;
     */
    runningHours: number;
}
/**
 * SimSandboxPoolState is one place sandboxes can be put, as its provider reported it when the stats were asked for.
 *
 * @generated from protobuf message simsandbox.v1.SimSandboxPoolState
 */
export interface SimSandboxPoolState {
    /**
     * @generated from protobuf field: string location = 1;
     */
    location: string;
    /**
     * @generated from protobuf field: string provider = 2;
     */
    provider: string;
    /**
     * Whether the pool would take a sandbox now: "available", or why not: "drained", "stocked_out", "full", or
     * "unreachable".
     *
     * @generated from protobuf field: string room = 3;
     */
    room: string;
    /**
     * The pool is marked to take no new sandboxes.
     *
     * @generated from protobuf field: bool drained = 4;
     */
    drained: boolean;
    /**
     * A pod in the pool has waited for a machine past the provisioning grace.
     *
     * @generated from protobuf field: bool stocked_out = 5;
     */
    stockedOut: boolean;
    /**
     * @generated from protobuf field: int64 sandboxes = 6;
     */
    sandboxes: string;
    /**
     * Machines sitting ready for a sandbox, held by the warm buffer.
     *
     * @generated from protobuf field: int64 warm_nodes = 7;
     */
    warmNodes: string;
    /**
     * The pool's node ceiling; zero when it could not be read.
     *
     * @generated from protobuf field: int64 max_sandboxes = 8;
     */
    maxSandboxes: string;
    /**
     * Why the pool could not be inspected, when it could not.
     *
     * @generated from protobuf field: string error = 9;
     */
    error: string;
}
/**
 * @generated from protobuf message simsandbox.v1.GetSimSandboxStatsResponse
 */
export interface GetSimSandboxStatsResponse {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start = 1;
     */
    start?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp end = 2;
     */
    end?: Timestamp;
    /**
     * Every launch attempt in the window, whether or not a provider accepted it.
     *
     * @generated from protobuf field: int64 launches = 3;
     */
    launches: string;
    /**
     * Launches a provider accepted.
     *
     * @generated from protobuf field: int64 accepted = 4;
     */
    accepted: string;
    /**
     * Launches confirmed running. A launch recorded before the running time was kept, which is started or ended for a
     * reason that means it ran, counts here and runs from its launch; only launches with a recorded running time enter
     * the time-to-running and warm-start figures.
     *
     * @generated from protobuf field: int64 started = 5;
     */
    started: string;
    /**
     * Launches no provider accepted.
     *
     * @generated from protobuf field: int64 failed = 6;
     */
    failed: string;
    /**
     * Sandboxes provisioning or started right now, launched in the window or not.
     *
     * @generated from protobuf field: int64 active_now = 7;
     */
    activeNow: string;
    /**
     * @generated from protobuf field: int64 distinct_parts = 8;
     */
    distinctParts: string;
    /**
     * @generated from protobuf field: int64 distinct_orgs = 9;
     */
    distinctOrgs: string;
    /**
     * Hours run during the window, summed as in SimSandboxLocationStat.
     *
     * @generated from protobuf field: double running_hours = 10;
     */
    runningHours: number;
    /**
     * running_hours priced at each location's node rate: what the machines under running sandboxes cost for the
     * time they ran them, not what was billed for them. Nodes held warm, nodes idle between sandboxes, and the
     * clusters' system pools are not included.
     *
     * @generated from protobuf field: double estimated_runtime_cost_usd = 11;
     */
    estimatedRuntimeCostUsd: number;
    /**
     * Of the started, how many were running within the warm-start threshold of their launch.
     *
     * @generated from protobuf field: int64 warm_starts = 12;
     */
    warmStarts: string;
    /**
     * The threshold warm_starts is measured against.
     *
     * @generated from protobuf field: int64 warm_start_threshold_ms = 13;
     */
    warmStartThresholdMs: string;
    /**
     * Launches first placed somewhere other than their preferred location.
     *
     * @generated from protobuf field: int64 spilled = 14;
     */
    spilled: string;
    /**
     * Launches moved to another location at least once while waiting for a machine.
     *
     * @generated from protobuf field: int64 relocated = 15;
     */
    relocated: string;
    /**
     * Launches destroyed for want of a machine by the provisioning deadline.
     *
     * @generated from protobuf field: int64 abandoned = 16;
     */
    abandoned: string;
    /**
     * @generated from protobuf field: optional int64 time_to_running_p50_ms = 17;
     */
    timeToRunningP50Ms?: string;
    /**
     * @generated from protobuf field: optional int64 time_to_running_p95_ms = 18;
     */
    timeToRunningP95Ms?: string;
    /**
     * @generated from protobuf field: repeated simsandbox.v1.SimSandboxCountStat by_state = 19;
     */
    byState: SimSandboxCountStat[];
    /**
     * @generated from protobuf field: repeated simsandbox.v1.SimSandboxCountStat by_termination_cause = 20;
     */
    byTerminationCause: SimSandboxCountStat[];
    /**
     * @generated from protobuf field: repeated simsandbox.v1.SimSandboxCountStat by_simulator = 21;
     */
    bySimulator: SimSandboxCountStat[];
    /**
     * @generated from protobuf field: repeated simsandbox.v1.SimSandboxLocationStat by_location = 22;
     */
    byLocation: SimSandboxLocationStat[];
    /**
     * @generated from protobuf field: repeated simsandbox.v1.SimSandboxDailyStat daily = 23;
     */
    daily: SimSandboxDailyStat[];
    /**
     * Ranked by running_hours and capped.
     *
     * @generated from protobuf field: repeated simsandbox.v1.SimSandboxOrgStat top_orgs = 24;
     */
    topOrgs: SimSandboxOrgStat[];
    /**
     * @generated from protobuf field: repeated simsandbox.v1.SimSandboxPartStat top_parts = 25;
     */
    topParts: SimSandboxPartStat[];
    /**
     * Every pool this deployment can place sandboxes in, in placement order, as of now.
     *
     * @generated from protobuf field: repeated simsandbox.v1.SimSandboxPoolState pools = 26;
     */
    pools: SimSandboxPoolState[];
}
/**
 * SandboxState is the recorded lifecycle state of a sandbox.
 *
 * @generated from protobuf enum simsandbox.v1.SandboxState
 */
export enum SandboxState {
    /**
     * @generated from protobuf enum value: SANDBOX_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * Recorded before the provider is asked to start the sandbox.
     *
     * @generated from protobuf enum value: SANDBOX_STATE_PENDING = 1;
     */
    PENDING = 1,
    /**
     * The provider has confirmed the sandbox is running.
     *
     * @generated from protobuf enum value: SANDBOX_STATE_STARTED = 2;
     */
    STARTED = 2,
    /**
     * The sandbox was never recorded as provisioning; one the provider did create was torn back down.
     *
     * @generated from protobuf enum value: SANDBOX_STATE_FAILED = 3;
     */
    FAILED = 3,
    /**
     * A provisioning or started sandbox was destroyed or found gone.
     *
     * @generated from protobuf enum value: SANDBOX_STATE_TERMINATED = 4;
     */
    TERMINATED = 4,
    /**
     * The provider accepted the sandbox but has not yet confirmed it running, e.g. while it waits for a GPU.
     *
     * @generated from protobuf enum value: SANDBOX_STATE_PROVISIONING = 5;
     */
    PROVISIONING = 5
}
/**
 * TerminationCause is what ended a failed or terminated sandbox.
 *
 * @generated from protobuf enum simsandbox.v1.TerminationCause
 */
export enum TerminationCause {
    /**
     * The sandbox has not ended.
     *
     * @generated from protobuf enum value: TERMINATION_CAUSE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * A user destroyed it.
     *
     * @generated from protobuf enum value: TERMINATION_CAUSE_USER = 1;
     */
    USER = 1,
    /**
     * Its idle watcher found no actuator had moved in an hour.
     *
     * @generated from protobuf enum value: TERMINATION_CAUSE_IDLE = 2;
     */
    IDLE = 2,
    /**
     * The provider stopped it, e.g. at its timeout.
     *
     * @generated from protobuf enum value: TERMINATION_CAUSE_PROVIDER = 3;
     */
    PROVIDER = 3,
    /**
     * Its container's own process exited.
     *
     * @generated from protobuf enum value: TERMINATION_CAUSE_EXITED = 4;
     */
    EXITED = 4,
    /**
     * It ended for a reason that was not recorded.
     *
     * @generated from protobuf enum value: TERMINATION_CAUSE_UNKNOWN = 5;
     */
    UNKNOWN = 5,
    /**
     * It could not be launched.
     *
     * @generated from protobuf enum value: TERMINATION_CAUSE_LAUNCH_FAILED = 6;
     */
    LAUNCH_FAILED = 6,
    /**
     * Its part, or the part's machine, was deleted.
     *
     * @generated from protobuf enum value: TERMINATION_CAUSE_PART_DELETED = 7;
     */
    PART_DELETED = 7,
    /**
     * No machine could be found for it in time, anywhere its provider could put it.
     *
     * @generated from protobuf enum value: TERMINATION_CAUSE_CAPACITY = 8;
     */
    CAPACITY = 8
}
/**
 * DestroyReason is why a sandbox is being destroyed.
 *
 * @generated from protobuf enum simsandbox.v1.DestroyReason
 */
export enum DestroyReason {
    /**
     * Treated as a user request, for callers that send no reason.
     *
     * @generated from protobuf enum value: DESTROY_REASON_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * The sandbox's idle watcher found no actuator had moved in an hour.
     *
     * @generated from protobuf enum value: DESTROY_REASON_IDLE = 1;
     */
    IDLE = 1,
    /**
     * A user asked for it.
     *
     * @generated from protobuf enum value: DESTROY_REASON_USER_REQUEST = 2;
     */
    USER_REQUEST = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateSimSandboxRequest$Type extends MessageType<CreateSimSandboxRequest> {
    constructor() {
        super("simsandbox.v1.CreateSimSandboxRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.CreateSimSandboxRequest
 */
export const CreateSimSandboxRequest = new CreateSimSandboxRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateSimSandboxResponse$Type extends MessageType<CreateSimSandboxResponse> {
    constructor() {
        super("simsandbox.v1.CreateSimSandboxResponse", [
            { no: 1, name: "sandbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.CreateSimSandboxResponse
 */
export const CreateSimSandboxResponse = new CreateSimSandboxResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DestroySimSandboxRequest$Type extends MessageType<DestroySimSandboxRequest> {
    constructor() {
        super("simsandbox.v1.DestroySimSandboxRequest", [
            { no: 1, name: "sandbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "reason", kind: "enum", T: () => ["simsandbox.v1.DestroyReason", DestroyReason, "DESTROY_REASON_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.DestroySimSandboxRequest
 */
export const DestroySimSandboxRequest = new DestroySimSandboxRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DestroySimSandboxResponse$Type extends MessageType<DestroySimSandboxResponse> {
    constructor() {
        super("simsandbox.v1.DestroySimSandboxResponse", [
            { no: 1, name: "success", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.DestroySimSandboxResponse
 */
export const DestroySimSandboxResponse = new DestroySimSandboxResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSimSandboxStatusRequest$Type extends MessageType<GetSimSandboxStatusRequest> {
    constructor() {
        super("simsandbox.v1.GetSimSandboxStatusRequest", [
            { no: 1, name: "sandbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetSimSandboxStatusRequest
 */
export const GetSimSandboxStatusRequest = new GetSimSandboxStatusRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSimSandboxStatusResponse$Type extends MessageType<GetSimSandboxStatusResponse> {
    constructor() {
        super("simsandbox.v1.GetSimSandboxStatusResponse", [
            { no: 1, name: "state", kind: "enum", T: () => ["simsandbox.v1.SandboxState", SandboxState, "SANDBOX_STATE_"] },
            { no: 2, name: "termination_cause", kind: "enum", T: () => ["simsandbox.v1.TerminationCause", TerminationCause, "TERMINATION_CAUSE_"] },
            { no: 3, name: "started_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetSimSandboxStatusResponse
 */
export const GetSimSandboxStatusResponse = new GetSimSandboxStatusResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSimSandboxPriceRequest$Type extends MessageType<GetSimSandboxPriceRequest> {
    constructor() {
        super("simsandbox.v1.GetSimSandboxPriceRequest", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetSimSandboxPriceRequest
 */
export const GetSimSandboxPriceRequest = new GetSimSandboxPriceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSimSandboxPriceResponse$Type extends MessageType<GetSimSandboxPriceResponse> {
    constructor() {
        super("simsandbox.v1.GetSimSandboxPriceResponse", [
            { no: 1, name: "usd_per_minute", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "monthly_credit_usd", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetSimSandboxPriceResponse
 */
export const GetSimSandboxPriceResponse = new GetSimSandboxPriceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMachineSimSandboxesRequest$Type extends MessageType<GetMachineSimSandboxesRequest> {
    constructor() {
        super("simsandbox.v1.GetMachineSimSandboxesRequest", [
            { no: 1, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetMachineSimSandboxesRequest
 */
export const GetMachineSimSandboxesRequest = new GetMachineSimSandboxesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetMachineSimSandboxesResponse$Type extends MessageType<GetMachineSimSandboxesResponse> {
    constructor() {
        super("simsandbox.v1.GetMachineSimSandboxesResponse", [
            { no: 1, name: "sandboxes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandbox }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetMachineSimSandboxesResponse
 */
export const GetMachineSimSandboxesResponse = new GetMachineSimSandboxesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimSandbox$Type extends MessageType<SimSandbox> {
    constructor() {
        super("simsandbox.v1.SimSandbox", [
            { no: 1, name: "sandbox_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "state", kind: "enum", T: () => ["simsandbox.v1.SandboxState", SandboxState, "SANDBOX_STATE_"] },
            { no: 4, name: "started_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "termination_cause", kind: "enum", T: () => ["simsandbox.v1.TerminationCause", TerminationCause, "TERMINATION_CAUSE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.SimSandbox
 */
export const SimSandbox = new SimSandbox$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSimSandboxStatsRequest$Type extends MessageType<GetSimSandboxStatsRequest> {
    constructor() {
        super("simsandbox.v1.GetSimSandboxStatsRequest", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "end", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetSimSandboxStatsRequest
 */
export const GetSimSandboxStatsRequest = new GetSimSandboxStatsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimSandboxCountStat$Type extends MessageType<SimSandboxCountStat> {
    constructor() {
        super("simsandbox.v1.SimSandboxCountStat", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.SimSandboxCountStat
 */
export const SimSandboxCountStat = new SimSandboxCountStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimSandboxLocationStat$Type extends MessageType<SimSandboxLocationStat> {
    constructor() {
        super("simsandbox.v1.SimSandboxLocationStat", [
            { no: 1, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "launches", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "started", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "spilled", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "relocated_in", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "relocated_out", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 8, name: "abandoned", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 9, name: "warm_starts", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 10, name: "active_now", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 11, name: "time_to_running_p50_ms", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 12, name: "time_to_running_p95_ms", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 13, name: "running_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "estimated_runtime_cost_usd", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.SimSandboxLocationStat
 */
export const SimSandboxLocationStat = new SimSandboxLocationStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimSandboxDailyStat$Type extends MessageType<SimSandboxDailyStat> {
    constructor() {
        super("simsandbox.v1.SimSandboxDailyStat", [
            { no: 1, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "launches", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 3, name: "started", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "failed", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "running_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.SimSandboxDailyStat
 */
export const SimSandboxDailyStat = new SimSandboxDailyStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimSandboxOrgStat$Type extends MessageType<SimSandboxOrgStat> {
    constructor() {
        super("simsandbox.v1.SimSandboxOrgStat", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "launches", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "running_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.SimSandboxOrgStat
 */
export const SimSandboxOrgStat = new SimSandboxOrgStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimSandboxPartStat$Type extends MessageType<SimSandboxPartStat> {
    constructor() {
        super("simsandbox.v1.SimSandboxPartStat", [
            { no: 1, name: "part_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "part_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "machine_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "launches", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "running_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.SimSandboxPartStat
 */
export const SimSandboxPartStat = new SimSandboxPartStat$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SimSandboxPoolState$Type extends MessageType<SimSandboxPoolState> {
    constructor() {
        super("simsandbox.v1.SimSandboxPoolState", [
            { no: 1, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "room", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "drained", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "stocked_out", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "sandboxes", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "warm_nodes", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 8, name: "max_sandboxes", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 9, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.SimSandboxPoolState
 */
export const SimSandboxPoolState = new SimSandboxPoolState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetSimSandboxStatsResponse$Type extends MessageType<GetSimSandboxStatsResponse> {
    constructor() {
        super("simsandbox.v1.GetSimSandboxStatsResponse", [
            { no: 1, name: "start", kind: "message", T: () => Timestamp },
            { no: 2, name: "end", kind: "message", T: () => Timestamp },
            { no: 3, name: "launches", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 4, name: "accepted", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 5, name: "started", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 6, name: "failed", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 7, name: "active_now", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 8, name: "distinct_parts", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 9, name: "distinct_orgs", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 10, name: "running_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 11, name: "estimated_runtime_cost_usd", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "warm_starts", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 13, name: "warm_start_threshold_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 14, name: "spilled", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 15, name: "relocated", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 16, name: "abandoned", kind: "scalar", T: 3 /*ScalarType.INT64*/ },
            { no: 17, name: "time_to_running_p50_ms", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 18, name: "time_to_running_p95_ms", kind: "scalar", opt: true, T: 3 /*ScalarType.INT64*/ },
            { no: 19, name: "by_state", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandboxCountStat },
            { no: 20, name: "by_termination_cause", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandboxCountStat },
            { no: 21, name: "by_simulator", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandboxCountStat },
            { no: 22, name: "by_location", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandboxLocationStat },
            { no: 23, name: "daily", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandboxDailyStat },
            { no: 24, name: "top_orgs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandboxOrgStat },
            { no: 25, name: "top_parts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandboxPartStat },
            { no: 26, name: "pools", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SimSandboxPoolState }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message simsandbox.v1.GetSimSandboxStatsResponse
 */
export const GetSimSandboxStatsResponse = new GetSimSandboxStatsResponse$Type();
/**
 * @generated ServiceType for protobuf service simsandbox.v1.SimSandboxService
 */
export const SimSandboxService = new ServiceType("simsandbox.v1.SimSandboxService", [
    { name: "CreateSimSandbox", options: {}, I: CreateSimSandboxRequest, O: CreateSimSandboxResponse },
    { name: "DestroySimSandbox", options: {}, I: DestroySimSandboxRequest, O: DestroySimSandboxResponse },
    { name: "GetSimSandboxStatus", options: {}, I: GetSimSandboxStatusRequest, O: GetSimSandboxStatusResponse },
    { name: "GetMachineSimSandboxes", options: {}, I: GetMachineSimSandboxesRequest, O: GetMachineSimSandboxesResponse },
    { name: "GetSimSandboxPrice", options: {}, I: GetSimSandboxPriceRequest, O: GetSimSandboxPriceResponse },
    { name: "GetSimSandboxStats", options: {}, I: GetSimSandboxStatsRequest, O: GetSimSandboxStatsResponse }
]);
